import {
  IcErrorCircleFill,
  IcErrorCircleRegular,
  IcInformationCircleFill,
  IcInformationCircleRegular,
  IcQuestionCircleLargeFill,
  IcQuestionCircleLargeRegular,
} from '@kep/kcds-icons';

import InfoButtonWithPopover from './InfoButtonWithPopover';
import InfoButtonWithTooltip from './InfoButtonWithTooltip';

import type { ReactNode } from 'react';
import type { InfoButtonIcon, InfoButtonProps } from './types';

const InverseButtonInformationIconSet: Record<InfoButtonIcon, ReactNode> = {
  information: <IcInformationCircleFill />,
  question: <IcQuestionCircleLargeFill />,
  error: <IcErrorCircleFill />,
};

const RegularButtonInformationIconSet: Record<InfoButtonIcon, ReactNode> = {
  information: <IcInformationCircleRegular />,
  question: <IcQuestionCircleLargeRegular />,
  error: <IcErrorCircleRegular />,
};

const InfoButton = (props: InfoButtonProps) => {
  const {
    className,
    alertType,
    size = 'sm',
    color = 'default',
    disabled,
    inverse = false,
    icon = 'information',
    arrow = 'down',
  } = props;

  const iconElement = inverse
    ? InverseButtonInformationIconSet[icon]
    : RegularButtonInformationIconSet[icon];

  if (alertType === 'popover') {
    const { popoverContentProps, popoverProps } = props;

    return (
      <InfoButtonWithPopover
        className={className}
        size={size}
        disabled={disabled}
        popoverProps={popoverProps}
        popoverContentProps={popoverContentProps}
        arrow={arrow}
        color={color}
      >
        {iconElement}
      </InfoButtonWithPopover>
    );
  }

  const { tooltipProps } = props;

  return (
    <InfoButtonWithTooltip
      className={className}
      size={size}
      disabled={disabled}
      tooltipProps={tooltipProps}
      arrow={arrow}
      inverse={inverse}
      color={color}
    >
      {iconElement}
    </InfoButtonWithTooltip>
  );
};

export default InfoButton;
